import { FC } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "~/components/ui/breadcrumb";

type BreadcrumbPathItem = {
  name: string;
  href: string;
};

type BreadcrumbsProps = {
  path: BreadcrumbPathItem[];
};

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ path }) => {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {path.map((item) => (
          <div className="flex items-center gap-3" key={item.href}>
            <BreadcrumbItem key={item.href}>
              <BreadcrumbLink href={item.href}>{item.name}</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-border">/</BreadcrumbSeparator>
          </div>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
